import { render, staticRenderFns } from "./bulk_add_wrestlers.vue?vue&type=template&id=4975383b&"
import script from "./bulk_add_wrestlers.vue?vue&type=script&lang=js&"
export * from "./bulk_add_wrestlers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports